/******************************************************************************
Report Reducer: Handles all interactions & state changes with the reports
component.
Hawaiian Macadamia Nut Services
Alexander Self
7/29/19
*******************************************************************************/
import { FETCH_CULTIVATION_REPORT } from '../actions/types';
let initState = {
  date: {},
  report: {}
};

export default function ReportReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_CULTIVATION_REPORT:
      return { ...state,
        report: action.payload
      };
    default:
      return state;
  }
}






















/* END */



// WEBPACK FOOTER //
// ./src/cultivation/reducers/report_reducer.js